export default function() {
    $(".pop-up-modal").click(function() {
        setTimeout(function() {
            $(".modal-dialog").addClass("modal-dialog-centered")
        }, 100)
    })
}